var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 py-3 px-5 shadow"},[_c('h4',[_vm._v(" "+_vm._s(_vm.pageTitle)+" "),(_vm.callInProgress)?_c('b-icon',{attrs:{"icon":"arrow-clockwise","animation":"spin"}}):_vm._e()],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }